import { c as _c } from "react/compiler-runtime";
import { getSubtitleApplyCheck, getSubtitlePluginPath, getSubtitleRequestList, getSubtitleStreamKey, postSubtitleCreateStreamKey, postSubtitleRefreshStreamKey, postSubtitleRequestHangul } from '@module/apis/client-side/subtitle';
import type { SubtitleApplyCheckResponse, SubtitlePluginPathResponse, SubtitlePluginPathType, SubtitleRequestHangulParams, SubtitleRequestHangulResponse, SubtitleRequestListResponse, SubtitleStreamKeyResponse } from '@module/apis/client-side/subtitle/type';
import { type UseMutationOptions, useMutation, useQuery } from '@tanstack/react-query';
import type { CustomUseQueryOptions } from '../type';
import { subtitleQueryKeys } from './subtitleQueryKeys';
export const useGetSubtitleRequestListQuery = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = subtitleQueryKeys.getSubtitleRequestList();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      queryKey: t0.queryKey,
      queryFn: _temp,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useQuery(t1);
};
export const useGetSubtitleApplyCheckQuery = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = subtitleQueryKeys.getSubtitleApplyCheck();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      queryKey: t0.queryKey,
      queryFn: _temp2,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useQuery(t1);
};
export const useGetSubtitlePluginPathQuery = (t0, options) => {
  const $ = _c(8);
  const {
    type
  } = t0;
  let t1;
  if ($[0] !== type) {
    t1 = subtitleQueryKeys.getSubtitlePluginPath(type);
    $[0] = type;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== type) {
    t2 = () => getSubtitlePluginPath({
      type
    });
    $[2] = type;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== options || $[5] !== t1.queryKey || $[6] !== t2) {
    t3 = {
      queryKey: t1.queryKey,
      queryFn: t2,
      ...options
    };
    $[4] = options;
    $[5] = t1.queryKey;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useQuery(t3);
};

// pandalive 일본어 닉네임 한글 번역
export const usePostSubtitleRequestHangulMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = subtitleQueryKeys.postSubtitleRequestHangul();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp3,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const useGetSubtitleStreamKeyQuery = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = subtitleQueryKeys.getSubtitleStreamKey();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      queryKey: t0.queryKey,
      queryFn: _temp4,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useQuery(t1);
};
export const usePostSubtitleRefreshStreamKeyMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = subtitleQueryKeys.postSubtitleRefreshStreamKey();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp5,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const usePostSubtitleCreateStreamKeyMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = subtitleQueryKeys.postSubtitleCreateStreamKey();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp6,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
function _temp() {
  return getSubtitleRequestList();
}
function _temp2() {
  return getSubtitleApplyCheck();
}
function _temp3(params) {
  return postSubtitleRequestHangul(params);
}
function _temp4() {
  return getSubtitleStreamKey();
}
function _temp5() {
  return postSubtitleRefreshStreamKey();
}
function _temp6() {
  return postSubtitleCreateStreamKey();
}